// ServiceList.tsx
import React from 'react';
import { Service, ServiceSelection, Reading, SpanishSelection } from '../../types';
import ServiceCard from '../../ServiceCard';

interface ServiceListProps {
  services: Service[];
  serviceSelections: ServiceSelection[];
  spanishSelections?: SpanishSelection[];
  readings: Reading[];
  onServiceUpdate: (service: Service) => void;
  onSelectionsUpdate: (serviceId: number, updatedSelections: ServiceSelection[]) => void;
  filterState?: {
    hideServiceMusic: boolean;
    selectedPerformanceTypes: number[];
  };
}

export const ServiceList: React.FC<ServiceListProps> = ({
  services,
  serviceSelections,
  spanishSelections = [],
  readings,
  onServiceUpdate,
  onSelectionsUpdate,
  filterState = { hideServiceMusic: false, selectedPerformanceTypes: [] }
}) => {
  return (
    <div className="service-list">
      {services.map((service) => (
        <div 
          key={service.service_id}
          id={`service-${service.service_id}`}
          className="service-item"
        >
          <ServiceCard
            service={service}
            selections={serviceSelections.filter(
              selection => selection.service_id === service.service_id
            )}
            spanishSelections={spanishSelections.filter(
              sel => sel.service_id === service.service_id
            )}
            reading={readings.find(
              reading => reading.service_id === service.service_id
            )}
            onUpdate={onServiceUpdate}
            onSelectionsUpdate={onSelectionsUpdate}
            filterState={filterState}
          />
        </div>
      ))}
    </div>
  );
};

export default ServiceList;